/**
 * table-filter
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default sb => {
    let filter,
        clearLink;

    const doFiltering = e => {
        sb.notify({type: "tableFilter", data: e.target.value});
    };

    const clear = e => {
        e.preventDefault();
        filter[0].value = "";
        sb.notify({type: "tableFilter", data: ""});
    };

    const showFilter = () => {
        if (filter) {
            return;
        }

        const container = sb.find(".filter");
        sb.append(container, [
            "<label for=\"filter\">Filter by name</label>",
            "<input id=\"filter\" type=\"text\">",
            "<a href=\"\">clear</a>"
        ].join("\n"));

        filter = sb.find("#filter");
        sb.addEvent(filter, "change", doFiltering);
        sb.addEvent(filter, "keyup", doFiltering);

        clearLink = sb.find("a");
        sb.addEvent(clearLink, "click", clear);
    };

    return {
        init() {
            sb.listen({tableUpdated: showFilter});
        },
        destroy() {
            if (filter !== null) {
                sb.removeEvent(filter, "change", doFiltering);
                sb.removeEvent(clearLink, "click", clear);
            }
            clearLink = null;
            filter = null;
        }
    };
};
